import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Euro, User, FileText, CreditCard, Check, Loader2 } from "lucide-react";

const PAYMENT_TYPES = {
  CASH: "Numéraire", BANCONTACT: "Bancontact (Payconiq)", QR_BANCONTACT: "QR code Bancontact",
  MYPOS: "Boîtier MyPos", TRANSFER: "Virement bancaire", INVOICE: "Facture à prévoir", OTHER: "Autre",
};

export const CashEntryForm = ({ amount, nature, payerLastName, payerFirstName, paymentType, loading, onAmountChange, onNatureChange, onLastNameChange, onFirstNameChange, onPaymentTypeChange, onSubmit }) => (
  <div className="bg-white rounded-xl border border-[#edf0f4] p-6">
    <form onSubmit={onSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="amount" className="flex items-center gap-2 text-[#162d3d]"><Euro size={16} className="text-[#22c55e]" /> Montant perçu *</Label>
        <div className="relative">
          <Input id="amount" type="number" step="0.01" min="0" placeholder="0.00" value={amount} onChange={(e) => onAmountChange(e.target.value)} className="pr-10 text-lg font-semibold" data-testid="input-amount" required />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8fa4b5] font-medium">€</span>
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="nature" className="flex items-center gap-2 text-[#162d3d]"><FileText size={16} className="text-[#8b5cf6]" /> Nature du paiement / Sujet *</Label>
        <Textarea id="nature" placeholder="Ex: Cours privé, Séance découverte, Vente produit..." value={nature} onChange={(e) => onNatureChange(e.target.value)} className="min-h-[80px]" data-testid="input-nature" required />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="payerLastName" className="flex items-center gap-2 text-[#162d3d]"><User size={16} className="text-[#3899ec]" /> Nom du payeur *</Label>
          <Input id="payerLastName" type="text" placeholder="Nom" value={payerLastName} onChange={(e) => onLastNameChange(e.target.value)} data-testid="input-payer-lastname" required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="payerFirstName" className="text-[#162d3d]">Prénom du payeur *</Label>
          <Input id="payerFirstName" type="text" placeholder="Prénom" value={payerFirstName} onChange={(e) => onFirstNameChange(e.target.value)} data-testid="input-payer-firstname" required />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="paymentType" className="flex items-center gap-2 text-[#162d3d]"><CreditCard size={16} className="text-[#f59e0b]" /> Mode de paiement *</Label>
        <Select value={paymentType} onValueChange={onPaymentTypeChange}>
          <SelectTrigger data-testid="select-payment-type"><SelectValue placeholder="Sélectionner un mode de paiement" /></SelectTrigger>
          <SelectContent className="z-[200]">
            {Object.entries(PAYMENT_TYPES).map(([key, label]) => <SelectItem key={key} value={key} data-testid={`payment-type-${key}`}>{label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="pt-4">
        <Button type="submit" disabled={loading} className="w-full h-12 bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg font-semibold" data-testid="submit-entry">
          {loading ? <><Loader2 size={20} className="mr-2 animate-spin" /> Enregistrement...</> : <><Check size={20} className="mr-2" /> Valider l'entrée</>}
        </Button>
      </div>
    </form>
  </div>
);
